<script setup lang="ts">
import { ref, computed } from 'vue';
import { SearchIcon, LockIcon, ShieldCheckIcon, LogoutIcon } from 'vue-tabler-icons';
// @ts-ignore
import Logo from '../logo/LogoMain.vue';
// @ts-ignore
import Searchbar from './SearchBarPanel.vue';
import AdminLoginDialog from '@/views/components/AdminLoginDialog.vue';
import AdminApprovalsDialog from '@/views/components/AdminApprovalsDialog.vue';
import { useAdminEditsStore } from '@/stores/adminEdits';
import { useVillagesStore } from '@/stores/villages';

const adminEditsStore = useAdminEditsStore();
const villagesStore = useVillagesStore();

const showSearch = ref(false);
const showLoginDialog = ref(false);
const showApprovalsDialog = ref(false);

// Only show Admin button when user searches for 'admin'
const isSearchingAdmin = computed(() => {
  return villagesStore.searchQuery.trim().toLowerCase().includes('admin');
});

function searchbox() {
  showSearch.value = !showSearch.value;
}

function handleAdminClick() {
  showLoginDialog.value = true;
}

function onAdminLoggedIn() {
  villagesStore.clearSearch();
  showApprovalsDialog.value = true;
}
</script>

<template>
  <v-app-bar elevation="0" height="80" class="app-header">
    <div class="pa-4 pa-sm-5 d-flex align-center">
      <Logo />
    </div>

    <!-- Actions Bar -->
    <div class="ml-auto mr-4 d-flex align-center" style="gap: 8px;">
      <!-- Search icon for mobile -->
      <v-btn
        class="hidden-lg-and-up text-secondary"
        color="lightsecondary"
        icon
        rounded="sm"
        variant="flat"
        size="small"
        aria-label="Open search"
        @click="searchbox"
      >
        <SearchIcon size="17" stroke-width="1.5" />
      </v-btn>

      <!-- Admin Mode: Logged in view -->
      <template v-if="adminEditsStore.isAdmin">
        <v-btn
          color="primary"
          variant="flat"
          size="small"
          rounded="lg"
          class="font-weight-bold"
          @click="showApprovalsDialog = true"
        >
          <ShieldCheckIcon size="16" class="mr-1" />
          <span class="d-none d-sm-inline">એડમિન પેનલ</span>
          <span class="d-inline d-sm-none">એડમિન</span>
          <v-badge
            v-if="adminEditsStore.pendingCount > 0"
            color="error"
            :content="adminEditsStore.pendingCount"
            inline
            class="ml-1"
          />
        </v-btn>

        <v-btn
          color="secondary"
          variant="tonal"
          size="small"
          icon
          rounded="lg"
          title="એડમિન લૉગઆઉટ"
          aria-label="Logout Admin"
          @click="adminEditsStore.logoutAdmin()"
        >
          <LogoutIcon size="16" />
        </v-btn>
      </template>

      <!-- Admin Mode: Logged out view (ONLY visible when 'admin' is searched) -->
      <template v-else-if="isSearchingAdmin">
        <v-btn
          color="primary"
          variant="flat"
          size="small"
          rounded="lg"
          class="font-weight-bold"
          title="એડમિન લૉગિન"
          @click="handleAdminClick"
        >
          <LockIcon size="14" class="mr-1" />
          <span>એડમિન લૉગિન</span>
        </v-btn>
      </template>
    </div>

    <!-- Search sheet for mobile -->
    <v-sheet v-if="showSearch" class="search-sheet v-col-12">
      <Searchbar :closesearch="searchbox" />
    </v-sheet>

    <!-- Search part for desktop -->
    <v-sheet class="search-wrap mr-6 d-none d-lg-block">
      <Searchbar />
    </v-sheet>

    <!-- Admin Dialogs -->
    <AdminLoginDialog
      v-model="showLoginDialog"
      @logged-in="onAdminLoggedIn"
    />
    <AdminApprovalsDialog
      v-model="showApprovalsDialog"
    />
  </v-app-bar>
</template>
